import { render, staticRenderFns } from "./TabsSection.vue?vue&type=template&id=2ab9574b"
import script from "./TabsSection.vue?vue&type=script&lang=js"
export * from "./TabsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports